import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "w-full" };
const _hoisted_2 = ["id", "disabled", "placeholder", "readonly", "type", "value", "maxlength"];
const _hoisted_3 = {
    key: 0,
    class: "text-body-4 shrink-0"
};
const _hoisted_4 = {
    key: 0,
    class: "c-inp-error-message text-body-6 mt-4"
};
import clsx from 'clsx';
import { tv } from 'tailwind-variants';
export default /*@__PURE__*/ _defineComponent({
    __name: 'BoxInput',
    props: {
        type: { default: 'text' },
        size: { default: 'large' },
        id: { default: undefined },
        placeholder: { default: undefined },
        modelValue: { default: '' },
        error: { type: Boolean },
        errorMessage: { default: undefined },
        isDisabled: { type: Boolean, default: false },
        isReadOnly: { type: Boolean, default: false },
        unitButtonText: { default: undefined },
        maxlength: {}
    },
    emits: ["update:modelValue"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const inputCover = tv({
            base: 'border-gray-250 has-disabled:border-gray-250 flex w-full items-center justify-between gap-8 border bg-white px-16 transition duration-200 ease-in-out hover:border-gray-700 has-focus:border-gray-700 has-disabled:bg-gray-100',
            variants: {
                size: {
                    small: 'rounded-6 py-7',
                    large: clsx('rounded-8 py-9', 'desktop:py-10'),
                },
            },
        });
        const input = tv({
            base: clsx('w-full text-gray-900 placeholder:text-gray-400 read-only:text-gray-400 read-only:text-gray-900 focus:outline-none disabled:text-gray-400', 'text-body-5', 'desktop:text-body-4'),
            variants: {},
        });
        const handleInput = (event) => {
            const target = event.target;
            emit('update:modelValue', target.value);
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", {
                    class: _normalizeClass([
                        _unref(inputCover)({
                            size: props.size,
                        }),
                        __props.error ? 'c-inp-error' : '',
                        __props.isReadOnly ? 'has-read-only:hover:border-gray-250 has-read-only:bg-gray-100' : '',
                    ])
                }, [
                    _createElementVNode("input", {
                        id: props.id,
                        class: _normalizeClass(_unref(input)()),
                        disabled: props.isDisabled,
                        placeholder: props.placeholder,
                        readonly: props.isReadOnly,
                        type: props.type,
                        value: props.modelValue,
                        maxlength: props.maxlength,
                        onInput: handleInput
                    }, null, 42, _hoisted_2),
                    (props.unitButtonText)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(props.unitButtonText), 1))
                        : _createCommentVNode("", true)
                ], 2),
                (props.error)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(props.errorMessage), 1))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
